import React from 'react';
import "./Sidebar.css";
import { Avatar } from "@material-ui/core";
import HomeIcon from "@material-ui/icons/Home";
import ChatIcon from "@material-ui/icons/Chat";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";
import AccountCircleOutlinedIcon from "@material-ui/icons/AccountCircleOutlined"
import HelpOutlinedIcon from "@material-ui/icons/HelpOutlined";
import ExitToAppIcon from "@material-ui/icons/ExitToAppRounded"
import { auth } from "../firebase";
import { Link } from "react-router-dom";

function Sidebar({ user }) {

    const handleLogout = (e) => {
        e.preventDefault();
        if (user) {
            auth.signOut();
        }
    }

    return (
        <div className="sidebar">
            <div className="sidebar__header">
                <Avatar src={user.photoURL} />
                <h3>Welcome, {user.displayName}</h3>
            </div>
            <div className="sidebar__main">
                <a href="/home">
                <div className="sidebar__options activated">
                    <HomeIcon />
                    <h3>Home</h3>
                </div>
                </a>
                <a href="https://instagram-clone-react-7d068.web.app">
                <div className="sidebar__options">
                    <ChatIcon />
                    <h3>Chat</h3>
                </div>
                </a>
                <a href="https://firestone-2ff13.web.app">
                <div className="sidebar__options">
                    <WarningRoundedIcon />
                    <h3>Covid-19 Tracker</h3>
                </div>
                </a>
                <Link className="link" to={`/${user?.displayName}/${user?.uid}`}>
                <div className="sidebar__options">
                    <AccountCircleOutlinedIcon />
                    <h3>Your Profile</h3>
                </div>
                </Link>
                <Link to="/help">
                <div className="sidebar__options">
                    <HelpOutlinedIcon />
                    <h3>Help</h3>
                </div>
                </Link>
                <div className="logout">
                    <ExitToAppIcon />
                </div>
            </div>
            <div className="sidebar__button">
                <button onClick={handleLogout} >Logout</button>
            </div>
        </div>
    )
}

export default Sidebar;